// sfc32 — small fast deterministic PRNG. ENGINE.md §Time Architecture.

export function sfc32(a: number, b: number, c: number, d: number): () => number {
  return function () {
    a |= 0; b |= 0; c |= 0; d |= 0;
    const t = (((a + b) | 0) + d) | 0;
    d = (d + 1) | 0;
    a = b ^ (b >>> 9);
    b = (c + (c << 3)) | 0;
    c = (c << 21) | (c >>> 11);
    c = (c + t) | 0;
    return (t >>> 0) / 4294967296;
  };
}

export function prngFromSeed(seed: number): () => number {
  let s = (seed | 0) || 1;
  const next = () => {
    s ^= s << 13; s ^= s >>> 17; s ^= s << 5;
    return s | 0;
  };
  return sfc32(next(), next(), next(), next());
}

/** Box-Muller — returns ~ N(0, 1). */
export function gauss(rng: () => number): number {
  const u = Math.max(1e-12, rng());
  const v = rng();
  return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
}
